import { computed, inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { pipe, switchMap, tap } from 'rxjs';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { CourtsService } from './courts.service';
import type { CourtDetails, CourtsDetails } from './courts.type';
import { setError, setLoaded, setLoading, withCallState } from '@ngrx-toolkit/core';

type State = {
  courts: CourtsDetails | null;
  court: CourtDetails | null;
};

const initialState: State = {
  courts: [],
  court: null,
};

export const CourtsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCallState(),
  withComputed(({ courts }, service = inject(CourtsService)) => ({
    options: computed(() => service.transform(courts())),
  })),
  withMethods((store, api = inject(CourtsService)) => ({
    loadCourts: rxMethod<void>(
      pipe(
        tap(() => patchState(store, setLoading())),
        switchMap(() =>
          api.loadList().pipe(
            tapResponse({
              next: (courts) => patchState(store, { courts }, setLoaded()),
              error: (error) => patchState(store, setError(error)),
            }),
          ),
        ),
      ),
    ),
    loadCourt: rxMethod<string>(
      pipe(
        tap(() => patchState(store, setLoading())),
        switchMap((id) =>
          api.loadCourt(id).pipe(
            tapResponse({
              next: (court) => patchState(store, { court }, setLoaded()),
              error: (error) => patchState(store, setError(error)),
            }),
          ),
        ),
      ),
    ),
  })),
);
